import { createPluginFactory } from '@udecode/plate'

import type {
  BufferEditor,
  BufferValue,
} from '~publish/legacy/editor/BufferEditor/types.plate'
import type { AutocompletePluginOptions } from '../autocomplete'
import { autocompleteOnKeyDownHandler } from '../autocomplete/handlers'
import { replaceTextAfterTriggerWithMention } from '../autocomplete/transforms/replaceTextAfterTriggerWithMention'
import { withAutocomplete } from '../autocomplete/withAutocomplete'
import { getNewSuggestionsOnMentionUpdate } from './api/getNewSuggestionsOnMentionUpdate'
import { findAndInsertLinkedInAnnotations } from './commands/findAndInsertLinkedInAnnotations'
import { normalizeLinkedInAnnotationNode } from './commands/normalizeLinkedInAnnotationNode'

import { getAllLinkedInAnnotations } from './commands/getAllLinkedInAnnotations'
import { insertLinkedInAnnotation } from './commands/insertLinkedInAnnotation'
import { LinkedInMentionUI } from './ui/LinkedInMentionUI'
import { LinkedInAnnotationInputElement } from './nodes/LinkedInAnnotationInputElement'
import debounce from 'lodash/debounce'
import { onSelectItem } from './queries/recentSuggestions'

export const createLinkedInAnnotationPlugin = createPluginFactory<
  AutocompletePluginOptions<LinkedInAnnotationInputElement>,
  BufferValue,
  BufferEditor
>({
  key: LinkedInAnnotationInputElement.type,
  isElement: true,
  isInline: true,
  component: LinkedInMentionUI,
  options: {
    textToNodes: findAndInsertLinkedInAnnotations,
    fetchNewSuggestions: debounce(getNewSuggestionsOnMentionUpdate, 200),
    normalizeNode: normalizeLinkedInAnnotationNode,
    onInsertTriggerBeforeText: replaceTextAfterTriggerWithMention,
    onSelectItem,
  },
  withOverrides: (editor, options) => {
    editor.insertLinkedInAnnotation = insertLinkedInAnnotation
    editor.getAllLinkedInAnnotations = getAllLinkedInAnnotations

    return withAutocomplete<LinkedInAnnotationInputElement>(
      LinkedInAnnotationInputElement,
    )(editor, options)
  },
  handlers: {
    onKeyDown: autocompleteOnKeyDownHandler({
      type: LinkedInAnnotationInputElement.type,
    }),
  },
})
